module.exports = __webpack_public_path__ + "img/action-cam-2.843fc69b.png";